import { BRAND } from "../lib/constants";
import { ArrowRight, Phone } from "lucide-react";

export const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full flex items-center overflow-hidden hero-radial"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={BRAND.heroBg}
          alt="Atlanta skyline"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/60 to-black" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 w-full grid lg:grid-cols-12 gap-8 items-center pt-32 pb-24">
        <div className="lg:col-span-8 fade-up">
          <div className="inline-flex items-center gap-3 mb-8 border border-zinc-800 px-4 py-2 bg-black/60 backdrop-blur-sm">
            <span className="w-1.5 h-1.5 bg-[#E50914] animate-pulse" />
            <span className="text-[10px] tracking-[0.3em] text-zinc-400 uppercase">
              Atlanta · Available Now
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl uppercase leading-[0.9] tracking-tighter"
          >
            Luxury.
            <br />
            <span className="text-[#E50914]">Safety.</span>
            <br />
            Experience.
          </h1>

          <p className="mt-8 max-w-xl text-base md:text-lg text-zinc-400 leading-relaxed">
            Premium black car service for weddings, proms, corporate, and VIP transport.
            Cadillac Escalade. Sprinter Van. White Rolls Royce. Professional chauffeurs.
            Available across Atlanta.
          </p>

          <div className="mt-12 flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo("#book")}
              data-testid="hero-book-btn"
              className="group bg-[#E50914] hover:bg-[#FF2A2A] text-white px-8 py-5 text-sm font-bold uppercase tracking-[0.25em] inline-flex items-center gap-3 transition-all duration-300 hover:shadow-[0_0_32px_rgba(229,9,20,0.5)]"
            >
              Reserve Your Ride
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href={BRAND.phoneLink}
              data-testid="hero-phone-btn"
              className="border border-zinc-700 px-8 py-5 text-sm font-bold uppercase tracking-[0.25em] inline-flex items-center gap-3 hover:bg-white hover:text-black transition-all duration-300"
            >
              <Phone className="w-4 h-4" />
              {BRAND.phone}
            </a>
          </div>

          {/* Stat row */}
          <div className="mt-16 grid grid-cols-3 gap-4 max-w-2xl">
            {[
              { k: "24/7", v: "Availability" },
              { k: "100%", v: "Chauffeur Verified" },
              { k: "5★", v: "VIP Experience" },
            ].map((s) => (
              <div key={s.v} className="border-l border-[#E50914] pl-4">
                <div className="font-display text-3xl md:text-4xl text-white">{s.k}</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-4 hidden lg:block fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="border border-zinc-800 bg-[#0A0A0A]/80 backdrop-blur-md p-8 relative">
            <div className="absolute -top-px -left-px w-12 h-px bg-[#E50914]" />
            <div className="absolute -top-px -left-px w-px h-12 bg-[#E50914]" />
            <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mb-4">
              Starting From
            </div>
            <div className="font-display text-5xl text-white">$120</div>
            <div className="text-sm text-zinc-400 mt-1 font-mono-data">/HOUR · ESCALADE 6+ HRS</div>
            <div className="h-px bg-zinc-800 my-6" />
            <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mb-4">
              Wedding Package
            </div>
            <div className="font-display text-3xl text-white">$1,000</div>
            <div className="text-sm text-zinc-400 mt-1">5 Hours · Red Carpet · Champagne</div>
          </div>
        </div>
      </div>
    </section>
  );
};
